import { BotProperty } from '../../../../BotProperties/components/Properties/types'

export default function(properties: Array<BotProperty>, idToFind:number | null): BotProperty | undefined {
  let result: BotProperty | undefined = undefined;

  function checkId(a: BotProperty) {
    if (a.id === idToFind) {
      result = a;

      return true;
    }

    return Array.isArray(a.properties) && a.properties.some(checkId);
  }

  if (!idToFind) {
    return result
  }

  properties.some(checkId);

  return result
}
